import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { parseDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';

export const isLaterThanAdminSetting = (
  dateString?: string | null,
  settings?: IAdminSetting[],
  settingCode?: AdminSettingCodesEnum,
) => {
  const setting = settings?.find(st => st.code === settingCode);
  const settingDate = setting?.value && parseDate({ date: setting?.value, parseFormat: DATE_FORMAT_LONG_FNS });

  if (!settingDate) {
    return true;
  }
  const date = (dateString && parseDate({ date: dateString, parseFormat: DATE_FORMAT_LONG_FNS })) ?? new Date();

  return date > settingDate;
};
